import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import { PerfilUsuarioComponent } from '../../forms/perfil-usuario/perfil-usuario.component';
import { MatDialog } from '@angular/material';
import { UtilServico } from 'src/app/servicos/util.servico';
import { reduce } from 'rxjs/operators';

@Component({
  selector: 'cdk-bases',
  templateUrl: './bases.component.html',
  styleUrls: ['./bases.component.scss']
})
export class BasesMenuComponent implements OnInit {
  isOpen: boolean = false;
  public dataSource = [];

  @Input() currentUser = null;
  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: MouseEvent, targetElement: HTMLElement) {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isOpen = false;
    }
    
  }

  constructor(
    private utilServico: UtilServico,
    public utilDadosLogado: UtilDadosLogado,
    private elementRef: ElementRef,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.utilDadosLogado.DadosAcesso().tecnico === 'S') {
      this.utilServico.Get('OrigemDados').subscribe(
        (result:any) => {
          this.dataSource = result;
        },
        (error:any) => {}
      );
    } else {
      this.utilServico.Get(`OrigemDados/GetOrigemDadosPorId/${this.utilDadosLogado.DadosAcesso().origem_dado_id}`).subscribe(
        (result:any) => {
          this.dataSource = result;
          this.AlterarFonte(result[0]);
        },
        (error:any) => {}
      );
    }
  }

  AlterarFonte(item: any): void {
    const dados = this.utilDadosLogado.DadosAcesso();
    localStorage.setItem('DadosAcesso', JSON.stringify(Object.assign(dados, { db_config: item })));
    this.isOpen = false;
  }
}
